import { useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { registerRequest, type RegisterRequest } from "@penn/web-common";
import type { AuthUser } from "@penn/web-common";

export interface UseRegisterOptions {
  onSuccess?: (user: AuthUser) => void;
}

export function useRegister(options: UseRegisterOptions = {}) {
  return useMutation<AuthUser, AxiosError<{ error?: { code?: string; message?: string } }>, RegisterRequest>({
    mutationFn: registerRequest,
    onSuccess: (user) => {
      options.onSuccess?.(user);
    },
  });
}
